import { Component } from '@theme/component';

/**
 * @typedef {object} ProductRelationsSelectRefs
 * @property {HTMLSelectElement} select
 */

/**
 * A custom element that navigates to the linked product picked in a relation dropdown
 * @extends Component<ProductRelationsSelectRefs>
 */
class ProductRelationsSelect extends Component {
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('pageshow', this.#showCurrentProduct);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('pageshow', this.#showCurrentProduct);
  }

  handleChange() {
    const url = this.refs.select.value;

    if (url) window.location.assign(url);
  }

  #showCurrentProduct = () => {
    const { select } = this.refs;
    const currentOption = select?.querySelector('option[selected]');

    if (currentOption instanceof HTMLOptionElement) select.value = currentOption.value;
  };
}

customElements.define('product-relations-select-component', ProductRelationsSelect);
